module.exports = __webpack_public_path__ + "img/pc_bg.248f719.webp";